@for (toast of toastService.toasts; track toast; let i = $index) {
<div
    class="toast d-flex flex-column align-content-center position-fixed"
    [ngClass]="toast.type == 'error' ? 'error' : ''"
    [ngStyle]="{ top: positionTop }"
>
    <div class="d-flex flex-row">
        <div class="d-flex flex-row align-items-center w-100">
            <div class="flex-column">
                @if (toast.type == 'policy-not-found') {
                <mat-icon [svgIcon]="'exclamation-circle'" style="color: white" alt="alert-icon-img"></mat-icon>
                <!-- <img src="assets/images/alert-icon.svg" alt="alert-icon-img" /> -->
                } @if (toast.type == 'error') {
                <mat-icon [svgIcon]="'exclamation-octagon'" style="color: white" alt="notification-icon-img"></mat-icon>
                <!-- <img src="assets/images/notification-icon-error.svg" alt="notification-icon-img" /> -->
                } @if (toast.type != 'error' && toast.type != 'policy-not-found') {
                <mat-icon [svgIcon]="'check-circle'" style="color: #41d23e" alt="notification-icon-img"></mat-icon>
                <!-- <img src="assets/images/notification-icon.svg" alt="notification-icon-img" /> -->
                }
            </div>
            <div class="d-flex flex-column flex-fill">
                <div class="text-break caption wh-100-color ps-2" [innerHTML]="toast.message"></div>
            </div>
            <div class="flex-column">
                <mat-icon
                    [svgIcon]="'close-alt'"
                    (click)="remove(i)"
                    alt="close-icon-img"
                    class="mat-icon-24 wh-100-color"
                ></mat-icon>
            </div>
        </div>
    </div>
</div>
}
